import { WithStyles } from 'decorators/withStyles';
import { IUserToken } from 'interfaces/userToken';
import React, { PureComponent } from 'react';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { ERROR_IMAGE } from 'settings';
import SwitchAccount from 'components/Layout/SwitchAccount';
interface IProps {
  classes?: any;
  user: IUserToken;
}

interface IState {
  isOpen: boolean;
}

@WithStyles(() => ({
  profile: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    padding: '1rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background-color  cubic-bezier(0.4, 0, 0.2, 1) 0.3s',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    },

    '&.clubeBlack': {
      '&:hover': {
        background: '#474747'
      }
    }
  },
  image: {
    '& img': {
      width: '50px',
      height: '50px',
      borderRadius: '50px'
    }
  },
  information: {
    width: '70%',
    marginLeft: '10px',
    color: '#fff',
    '& span': {
      margin: 0,
      fontSize: '18px'
    },
    '& p': {
      margin: 0,
      textTransform: 'uppercase',
      fontSize: '12px'
    }
  },

  chevron: {
    width: '35px',
    height: '35px',
    color: '#fff',
    transition: 'transform 0.4s ease-in-out',
    '&.chevronUp': {
      transform: 'rotate(-180deg)'
    },

    '&.chevronDown': {
      transform: 'rotate(0deg)'
    }
  }
}))
export default class Profile extends PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { isOpen: false };
  }

  toggleMenu = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { user } = this.props;
    const { image, profile, information, chevron } = this.props.classes;
    const chevronDirection = this.state.isOpen ? 'chevronUp' : 'chevronDown';

    return (
      <div className={`${profile} ${user.isClubeBlack ? 'clubeBlack' : ''} `} onClick={this.toggleMenu}>
        <div className={image}>
          <img
            src={user?.photo}
            alt={user?.name}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = ERROR_IMAGE;
            }}
          />
        </div>
        <div className={information}>
          <p>Bem vindo</p>
          <span>{user?.name}</span>
        </div>
        <ChevronDownIcon className={`${chevron} ${chevronDirection}`} />
        {this.state.isOpen && <SwitchAccount />}
      </div>
    );
  }
}
